<template>
  <div>
    <NavTop :parentData="this.$route.params.tabBarId" class="navbar">
    </NavTop>
    <!-- 轮播图 -->
    <div class="block">
      <swiper class="swiper" :options="swiperOptions">
        <swiper-slide class="swiper_img" v-for="(slide, index) in slides" :key="index">
          <img style="width: 100%;height: 450px;cursor: pointer" :src="slide.url" alt="Slide Image">
<!--          @click.stop="clickRoute('/bannerDetail',slide.id)"-->
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div ref="targetDiv"></div>
    </div>
    <div class="center">
      <DetailedPage></DetailedPage>
      <div class="right_box">
        <div class="right_box_t">
          <div class="title">{{ title }}</div>
          <div class="right_link">
            <span class="right_link1" to="/">首页</span>
            /
            <span v-if="two.txt" class="right_link2">{{ two.txt }}/
            </span>
            <span class="right_link3">{{ title }}</span>
          </div>
        </div>
        <!-- 学校简介 -->
        <div v-if="biaoji == 10" class="txt">
          河北东方学院是教育部批准设立的一所民办地方性应用型本科高校，地处京津走廊——河北省廊坊市东方大学城，距北京天安门46公里，占据了得天独厚的地缘优势。学校建有省级博物馆、校内艺术馆、高尔夫练习馆、网球馆、游泳馆等。是周杰伦歌曲《浪漫手机》MV的拍摄地，是张艺谋导演的电影《第二十条》的取景地。校园四季如画，欧式建筑别具风格。

          学校现有全日制在校生33,000余人，设有7个二级学院，文物艺术学院、数字传媒学院、人工智能学院、医学院、经济管理学院、人文学院、马克思主义学院。开设28个本科专业，涵盖艺术学、历史学、工学、经济学、管理学、文学、医学、教育学八个学科门类。形成了以文物艺术为特色，以人工智能技术为引领的文理交融，专业互通，相互支撑的学科专业布局。

          学校坚持“文化引领、立德树人”，为党育人，为国育才。是“中华优秀传统文化教育研究实践基地”、“全国高校美育教学实践基地”、“全国五四红旗团支部”。培养了见义勇为的好学生李浩、李海鹏，培养了“全国高校毕业生基层就业卓越奖”获得者海涛。是河北省版权示范单位、河北省众创空间，平均每年都有4000多件师生作品获得版权登记或专利，享有创新知识产权。《2024年ABC中国民办大学排名》学校位列第73名，2023校友会《中国大学一流专业排名（应用型）》学校文物与博物馆学和文物保护与修复专业分别位列第2名和第3名。

          学校坚持“专家引领、名师执教”，形成了专家支撑专业建设和人才培养的基本格局。引进了一批享受国务院、政府特殊津贴的专家和学者及博士生导师、当代知名艺术家、企业家、技术大师、非遗传承人等行业领军人物担纲专业带头人。目前学校有5个省级一流专业，11门省级一流课程和精品在线开放课程，3个省级优秀教师团队和多名省级教学名师、1个省级高校优秀基层教学组织、21个省级高校达标基层教学组织。教师在河北省高校教师教学创新大赛和西浦全国大学教学创新大赛中屡创佳绩。是河北省实验教学和教学实验室建设研究项目立项单位，是教育部高等学校虚拟仿真教学创新实验室项目立项单位，是教育部全国应用型人才培养基地。

          学校坚持“产教融合、校企一体”，实现了人才培养供给侧和产业需求侧的高度耦合。与中国文物保护技术协会、国家博物馆、北京国博文化遗产研究院等深度合作，建设了省内高校首家具有省文物局认定资质的“文物保护修复综合技术中心”，秉持“文物+艺术+科技”的人才培养理念，采取基于项目的教育与学习，实现了知识和能力的同步培养。

          引企入校，把企业资源与学校资源有效整合，学校与企业变成了“共同体”，对学生实行“一体化合作培养”。引进北京正元特道科技有限公司，为数字传媒人才培养建设了校内外实训基地。引进北京精准高尔夫培训机构，合作成立高尔夫产业学院，共同开发特色课程与教材。在第五届全国高等院校高尔夫冠军赛中获得佳绩，师生分别获得冠军和个人技能大赛一等奖。

          依托毗邻人工智能产业园的产业集群优势，对接廊坊建设京津冀电子信息走廊的发展定位，在全国高校中率先开设了虚拟现实技术专业和人工智能专业，是新工科产学研联盟虚拟现实教育工作委员会成员，是全国虚拟现实技术专业建设方案及课程体系标准编制单位之一，有较强的教学、科研实力和行业服务能力，与企业互促互进、相互依存、共建协同创新中心，共同研发的720VR影院已落户圆明园。

          经济管理学院将四大会计事务所之一的安永公司培训课程嵌入人才培养方案，实行定制培养，每年都有几十名毕业生进入安永中国——北京分公司、大连和济南分公司。

          医学院实行“2+1+1”分段培养，本着早临床、多临床、反复临床的宗旨，第三学年把教室搬到医院，由学校教师和医院主任医师共同授课，实施人才培养主体的“双元化”，人才培养过程的“员工化”。在真实的职业情境中，培养学生行业实践能力，建立行业文化自觉。

          学校始终把服务地方经济社会发展，作为自身的责任和使命，寻找契合点，与区域创新发展同频共振。学校是京津冀博物馆协同发展推进工作办公室授予的：京津冀博物馆文化创意基地、京津冀博物馆研学游体验基地、京津冀文博教育培训基地；是廊坊市版权服务工作站、廊坊市文创版权孵化基地、廊坊市知识产权信息公共服务网点、是廊坊市文物保护修复基地、廊坊市中小学生研学游实践基地。与廊坊市广告协会联合成立廊坊市广告研究院，与廊坊市文物保护研究所共建文化遗产保护研究中心，与廊坊市广阳区文旅局共建非遗传承创新中心。

          学校秉承“人文、智慧、开放”的办学理念，以校企合作、产教融合为主要路径，努力提升对区域经济社会发展的贡献力，培养德智体美劳全面发展，具有创新精神、实践能力和人文素养的应用型人才，让每一位学子在与时俱进的河北东方学院扬起成长成才的理想风帆，逐梦远航！筑梦东方，圆梦东方！
        </div>
        <!-- 现任领导 -->
        <div v-if="biaoji == 11">
          <div class="currentLeader">
            <ul class="currentLeader_ul">
              <li class="currentLeader_li" v-for="(item,index) in ppp" :key="index">
                <i class="currentLeader_i">
                  <span class="currentLeader_span">
                    <img src="https://www.hkc.edu.cn/Public/Upload/image/20180803/5b640a9742091.jpg" alt>
                  </span>
                </i>
                <div class="currentLeader_text">
                  <h4>
                    <span>{{ item.txt }}</span>
                  </h4>
                  <p>
                    <span>家级课题4项，主持省级科研和教研课题16项。获得教研、科研成果奖励</span>
                  </p>
                  <div>
                    <span>2018.08.02</span>
                    <span>查看更多>></span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div style=" width: 100%;margin-bottom: 15px;display: flex;justify-content: center">
            <el-pagination background layout="prev, pager, next" :total="50"/>
          </div>
        </div>
        <!-- 校园导航 -->
        <div v-if="biaoji == 12" style="display: flex;justify-content: center;padding-top: 10px;">
          <Map></Map>
        </div>
        <div v-if="biaoji == 45"></div>
        <div v-if="biaoji == 592"></div>
      </div>
    </div>

  </div>
</template>
<script>
import NavTop from '../../components/comcomponents/NavTop.vue'
import Map from '../../components/Map/Map.vue'
import home from '../../api/home.js'

export default {
  components: {Map, NavTop},
  data () {
    return {
      swiperOptions: {
        pagination: {el: '.swiper-pagination', clickable: true},
        navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
        loop: true,
        autoplay: {
          delay: 2500,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        speed: 10000
      },
      slides: [],
      two: {
        txt: '部门职责'
      },
      // 标记
      biaoji: 10,
      title: '学校简介',
      interval: null,
      currentIndex: 0, // 新闻轮播图
      currentIndexBanner: 0, // banner轮播图
      // 首页头部轮播图
      bannerImg: [
        require('../../assets/images/banner1.png'), // 替换为你的图片路径
        require('../../assets/images/banner2.png'),
        require('../../assets/images/banner3.png'),
        require('../../assets/images/banner2.png'),
      ],
      navItems: [
        {name: '首页', path: '/home'},
        {name: '学校简介', path: '/profile/10'},
        {name: '现任领导', path: '/profile/11'},
        {name: '校园导航', path: '/profile/12'},
        {name: 'VR校园全景', path: '/profile/592'}
      ],
      // 现任领导数据
      ppp: [{txt: '1'},
        {txt: '2'},
        {txt: '3'}],
      shujv:{}
    }
  },
  created () {
    this.getTu() // 获取轮播图
    // 组件创建时获取路由参数
    console.log('Profile ID:', this.$route.params.id)
    this.PanDuan(this.$route.params.id)
  },
  watch: {
    // 观察 $route 对象的变化
    '$route' (to, from) {
      // 这里可以根据 to.params 来获取新的参数
      console.log('New params:', to.params)
      // 根据参数变化执行相应的逻辑
      this.PanDuan(to.params.id)
      this.sceoll()
    }
  },
  mounted () {
    this.sceoll()
  },
  methods: {
    // 点击学校新闻产学研用列表
    clickRoute (path, id) {
      this.$router.push(path + '/' + id)
    },
    // 滑动
    sceoll () {
      const targetLocation = this.$refs.targetDiv
      if (targetLocation) {
        targetLocation.scrollIntoView({behavior: 'smooth'})
      }
    },
    // 获取首页轮播图
    async getTu () {
      try {
        const res = await home.getBanner()
        if (res.code === 200) {
          this.slides = res.rows
        }
      } catch (e) {
        console.error(e)
      }
    },
    // 判断
    PanDuan (val) {
      const that = this
      switch (val) {
        case '10' :
          that.biaoji = val
          that.title = '学校简介'
          break
        case '11':
          that.biaoji = val
          that.title = '现任领导'
          break
        case '12':
          that.biaoji = val
          that.title = '校园导航'
          break
        case '45':
          that.biaoji = this.$route.params.id
          that.navItems = [
            {name: '首页', path: '/home'},
            {name: '党委组织部', path: '/profile/45'}
          ]
          that.two.txt = ''
          that.title = '党委组织部'
          that
        case '592' :
          that.biaoji =val
          that.title = '党委组织部'
      }
    },
    // 跳转链接
    navigateTo (path) {
      this.$router.push(path)
    }
  }

}
</script>

<style lang="less" scoped>
.block {
  margin-bottom: 40px;
}

.center {
  margin: 0 auto;
  width: 1200px !important;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.right_box {
  width: 960px;

  .right_box_t {
    height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;

    .title {
      width: 80px;
      height: 45px;
      padding: 0 15px;
      line-height: 45px;
      font-size: 20px;
      font-weight: bold;
      color: #444;
      border-bottom: 2px solid #9e070e;
      box-sizing: content-box;
    }

    .right_link {
      font-size: 14px;
      color: #666;

      .right_link1 {
        cursor: pointer;
        font-size: 14px;
        color: #666;

        &:hover {
          text-decoration: underline;
        }
      }

      .right_link2 {
        cursor: pointer;
        font-size: 14px;
        color: #666;

        &:hover {
          text-decoration: underline;
        }
      }

      .right_link3 {
        font-size: 14px;
        color: #666;
      }
    }
  }
}


.title {
  width: 150px;
  height: 50px;
  padding-top: 10px;
  border-bottom: 3px solid #9e070e;
}


.right_link {
  color: #666;
  font-size: 14px;
}

.txt {
  padding: 40px 0;
  text-indent: 2em;
  line-height: 2em;
  font-size: 20px;
  color: #333;
}
</style>
<!--相关领导样式-->
<style lang="less" scoped>
.currentLeader {
  overflow: hidden;
  margin: 0 auto;
  padding-top: 20px;

  .currentLeader_ul {
    overflow: hidden;
    margin: 0 auto;
  }

  .currentLeader_li {
    margin-top: 0 !important;
    overflow: hidden;
    margin: 30px auto;

    .currentLeader_i {
      overflow: hidden;
      margin: 0 auto;
      display: block;
      width: 350px;
      height: 212px;
      float: left;

      .currentLeader_span {
        color: #337ab7;
        cursor: pointer;

        img {
          overflow: hidden;
          margin: 0 auto;
          display: block;
          width: 350px !important;
          height: 212px !important;
          object-fit: cover;
        }
      }
    }

    .currentLeader_text {
      overflow: hidden;
      margin: 0 auto;
      width: calc(100% - 350px);
      float: left;
      padding-left: 40px;
      cursor: pointer;

      &:hover {
        h4 {
          span {
            color: #3999DC !important;
          }
        }

        p {
          span {
            color: #3999DC;
          }
        }

        div {

          span {
            &:nth-child(2) {
              width: 120px;
              color: #fff;
              background-color: #3999dc;
            }
          }
        }
      }

      h4 {
        overflow: hidden;
        margin: 0 auto 30px;
        font-size: 24px;
        color: #333333;
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;

        span {
          color: #333333;
          cursor: pointer;
        }
      }

      p {
        overflow: hidden;
        margin: 0 auto;
        font-size: 14px;
        color: #999999;
        height: 125px;

        span {
          color: #999999;
          cursor: pointer;
        }
      }

      div {
        overflow: hidden;
        margin: 0 auto;

        span {
          &:nth-child(1) {
            overflow: hidden;
            margin: 0 auto;
            display: block;
            height: 30px;
            line-height: 32px;
            float: left;
            font-size: 14px;
            color: #cccccc;
            padding-left: 20px;
            background: url(../../assets/images/span_ico.png) no-repeat left center;
          }

          &:nth-child(2) {
            width: 100px;
            height: 30px;
            overflow: hidden;
            display: block;
            line-height: 30px;
            float: right;
            font-size: 14px;
            color: #666666;
            padding-left: 20px;
            margin-right: 0;
            transition: .3s;
          }
        }
      }
    }
  }

}
</style>
<style lang="less">
.swiper-pagination {
  /* 未选中时的分页器子弹样式 */

  .swiper-pagination-bullet {
    background-color: #000 !important; /* 未选中时的背景色 */
    width: 8px;
    height: 8px;
    opacity: 0.3 !important;
    //transition: background-color 0.3s, transform 0.3s !important;
  }

  /* 选中时的分页器子弹样式 */

  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: #8D080E !important; /* 选中时的背景色 */
    width: 15px !important; /* 选中时的宽度 */
    height: 8px;
    opacity: 1 !important;
    border-radius: 5px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/profile/profile.vue